import { useSessionTutorial } from '@/features/session-tutorial/SessionTutorialProvider';
import type { TutorialStepUnavailableProps } from '@/features/session-tutorial/sessionTutorial.types';
import { useEffect } from 'react';

/** Rendered where a step's control would be once it is known it will not appear; withdrawn on unmount. */
export const TutorialStepUnavailable = ({ step }: TutorialStepUnavailableProps) => {
  const markUnavailable = useSessionTutorial()?.markUnavailable;
  useEffect(() => markUnavailable?.(step), [markUnavailable, step]);
  return null;
};
